import { environment as env } from '@environments/environment';

const BASE = env.api;

export const API = {
	auth: {
		login: `${BASE}auth`,
		updateMobile: `${BASE}auth/update`,
		deleteAccount: `${BASE}auth/destroy`,
		checkPhoneRegistered: `${BASE}auth/exist`,
		twilioSendOtp: `${BASE}auth/otp`,
		verifyOtp: `${BASE}auth/verify`,
		validatePhone: `${BASE}auth/validatePhone`,
		validateToken: `${BASE}auth/validateToken`,
	},
	ads: {
		adListCount: `${BASE}user-ads-count`,
		adList: `${BASE}ads/vip`,
	},
};
